import { Loader2 } from "lucide-react"
import { Activity, LoanOfficer } from "../../../../types"
import { ActivityDescription } from "../utlis"
import RoundedImg from "../../rounded-img"
import ActivityIcon from "../icon"
import { useActivityNavigation } from "../hooks/useActivityNavigation"

interface Props {
  activity: Activity
  member?: LoanOfficer
  isLoActivity?: boolean
  isBrandActivity?: boolean
  // Optional: allow parent to control navigation states
  isNavigating?: boolean
  onClick?: () => void
}

const ActivityCard = ({
  activity,
  member,
  isLoActivity,
  isBrandActivity,
  isNavigating: externalIsNavigating,
  onClick: externalOnClick
}: Props) => {
  const internalNav = useActivityNavigation(activity)

  const isNavigating = externalIsNavigating ?? internalNav.isNavigating
  const handleClick = externalOnClick ?? internalNav.handleClick

  const imageSrc = isBrandActivity
    ? member?.picture ?? member?.logo
    : member?.logo

  const showImage = imageSrc && (isLoActivity ? member?.picture : true)

  const loName = activity.loan_officer_name || activity.detail?.lo?.name || null

  return (
    <div
      onClick={handleClick}
      className={`group relative flex flex-col sm:flex-row sm:items-start gap-3 py-3 px-2 transition-all duration-150 ${
        isNavigating ? "opacity-50 pointer-events-none" : ""
      }`}
    >
      {/* Icon/Avatar */}
      <div className="relative z-10 w-8 shrink-0 mt-0.5">
        {isNavigating ? (
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center">
            <Loader2 className="w-4 sm:w-3.5 h-4 sm:h-3.5 text-white animate-spin" />
          </div>
        ) : showImage ? (
          <div className="w-8 h-8 rounded-full overflow-hidden ring-1 ring-slate-200/50 group-hover:ring-primary-300 transition-all duration-150">
            {isLoActivity && member?.picture ? (
              <RoundedImg src={member.picture} alt={member?.name} />
            ) : (
              <img
                src={imageSrc}
                alt={member?.name}
                className="w-full h-full object-cover"
              />
            )}
          </div>
        ) : (
          <ActivityIcon activity={activity} />
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="leading-tight text-slate-700 group-hover:text-slate-900 transition-colors duration-100">
          <ActivityDescription activity={activity} hideOwner />
        </div>
        {loName && <p className="text-xs text-slate-400 mt-0.5">{loName}</p>}
      </div>
    </div>
  )
}

export default ActivityCard
